<template>
  <div @click="$emit('clickNote')">
    <div v-show="visible" ref="wrapper" :class="['edit', isFocus ? 'z-10' : '']" :style="style">
      <!-- ref title 用于拖拽 -->
      <div ref="title" class="note-title">
        <div class="w-full h-full relative flex items-center textarea-wrapper">
          <textarea
            ref="noteTitle"
            v-model="userInput.title"
            class="textarea title-text"
            rows="1"
            placeholder="请输入笔记标题"
            @mousedown.stop
          ></textarea>
          <div
            :class="[
              'count-number',
              userInput.title.length > userInputMax.title ? 'count-number-red' : ''
            ]"
          >
            {{ userInput.title.length }}/{{ userInputMax.title }}
          </div>
        </div>
      </div>
      <div class="hr"></div>
      <div class="flex-1 flex flex-col p-4 pb-1">
        <div class="w-full h-full relative flex flex-col textarea-wrapper">
          <textarea
            v-model="userInput.content"
            class="textarea content-text"
            placeholder="请输入笔记内容"
          ></textarea>
          <div
            :class="[
              'count-number',
              userInput.content.length > userInputMax.content ? 'count-number-red' : ''
            ]"
          >
            {{ userInput.content.length }}/{{ userInputMax.content }}
          </div>
        </div>
      </div>
      <div class="action-wrapper">
        <div class="flex justify-end mx-6 mb-2">
          <button class="button cancel-button" @click="handleCancel">取 消</button>
          <button
            :class="[
              'button confirm-button',
              userInput.content.length && userInput.title.length ? '' : 'disabled'
            ]"
            @click="handleSubmit"
          >
            保 存
          </button>
        </div>
      </div>
    </div>
    <SaveAfterShow ref="saveAfterShow" :isFocus="isFocus" :visible.sync="saveAfterShowVisible" />
  </div>
</template>
<script lang="ts">
import { Content } from '@forchange/storytime';
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { SystemData } from '..';
import Position from '../mixins/position';
import CREATE_NOTE from '../graphql/createNote';
import SaveAfterShow from './SaveAfterShow.vue';

@Component({
  components: {
    SaveAfterShow
  }
})
export default class NoteEdit extends Mixins(Position) {
  @Prop({ type: Boolean }) visible: Boolean;
  // 滞后 为绑定时content
  @Prop({ type: Object }) content: Content & {
    noteIds: any;
    messages: Array<string>;
  };
  @Prop({ type: String }) selectValue: String;
  @Prop({ type: Number }) changeTime: number;
  @Prop({ type: Boolean }) isFocus: boolean;
  @Prop({ type: Object }) system: SystemData;

  userInputMax = {
    title: 50,
    content: 800
  };

  userInput = {
    title: '',
    content: ''
  };

  // 展示框展示标识
  saveAfterShowVisible = false;

  get style() {
    return {
      top: (this.position.top || 0) + 'px',
      left: (this.position.left || 0) + 'px'
    };
  }

  @Watch('visible')
  visibleChange() {
    if (this.visible) {
      // 清除展示页
      this.saveAfterShowVisible = false;
    }
    this.$nextTick(() => {
      this.initPosition();
    });
  }

  mounted() {
    this.initPosition();
    this.bindEvents();

    this.$nextTick(() => {
      (this.$refs.noteTitle as HTMLTextAreaElement)?.focus();
    });
  }

  close() {
    this.$emit('update:visible', false);
  }

  handleCancel() {
    this.$emit('update:visible', false);
    this.userInput.title = '';
    this.userInput.content = '';
  }

  async handleSubmit() {
    if (!this.checkValue()) return;
    if (!this.$getClemanClient().token)
      return this.$Message.warn({
        time: 3000,
        content: '请先登录后再进行笔记记录哦'
      });
    try {
      const noteId = await this.$getClemanClient().apollo.mutate({
        mutation: CREATE_NOTE,
        variables: {
          create: {
            courseVersion: this.system.version,
            courseId: this.system.courseId,
            resourceId: this.content.$id,
            resourceType: this.content.$kind,
            selectValue: this.content.messages[this.system.utteranceIndex],
            noteTitle: this.userInput.title,
            noteContent: this.userInput.content
          }
        }
      });
      const currentContent =
        (window.storyteller.topSequence?.contents.filter(
          (item) => (item as any as { $id: string }).$id === this.content.$id
        )[0] as Content & {
          noteIds: any;
          messages: Array<string>;
        }) || undefined;

      const noteIds = currentContent?.noteIds?.[this.system.utteranceIndex] || [];
      const currentNoteIds = [noteId.data.createCourseLearningNote.id, ...noteIds];

      window.storyteller.updateAssignContent({
        $id: this.content.$id,
        $kind: this.content.$kind,
        ...{
          noteIds: {
            ...this.content.noteIds,
            ...{
              [this.system.utteranceIndex]: currentNoteIds
            }
          },
          // 更新不触发loading
          touchLoading: false,
          // 清除笔记中标记
          takingNotes: -1
        }
      });
      this.$Message.success({
        time: 2500,
        content: '添加笔记成功'
      });
      this.$emit('addSuccess');
      // 打开展示栏
      const saveAfterShow = this.$refs.saveAfterShow as Vue & { open: Function };
      saveAfterShow.open(
        {
          ...this.position
        },
        {
          ...this.userInput
        }
      );
      // 清除当前填写数据
      this.handleCancel();
    } catch (error) {
      this.$Message.error({
        time: 2500,
        content: '请求貌似出了些问题，可以尝试重新填写'
      });
      console.log(error);
    }
  }
  checkValue() {
    if (this.userInput.title.length <= 0) {
      this.$Message.warn({
        time: 1500,
        content: '笔记标题需要填写哦'
      });
      return false;
    }

    if (this.userInput.title.length > this.userInputMax.title) {
      this.$Message.warn({
        time: 1500,
        content: '标题太多啦，按照右下角数字提示稍微删减一点吧！'
      });
      return false;
    }

    if (this.userInput.content.length <= 0) {
      this.$Message.warn({
        time: 1500,
        content: '笔记内容需要填写哦'
      });
      return false;
    }

    if (this.userInput.content.length > this.userInputMax.content) {
      this.$Message.warn({
        time: 1500,
        content: '内容太多啦，按照右下角数字提示稍微删减一点吧！'
      });
      return false;
    }
    return true;
  }
}
</script>
<style scoped>
.edit {
  @apply flex resize min-h-60 min-w-60 flex-col fixed w-5/6 h-120 max-w-full max-h-full rounded-md overflow-hidden bg-white;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
}

@screen md {
  .edit {
    width: 476px;
    height: 269px;
  }
}
.note-icon {
  -webkit-user-drag: none;
}
/* common */
.textarea {
  @apply p-0 ring-0 border-none resize-none;
}

.textarea-wrapper {
  @apply overflow-hidden;
}

/* text number */
.count-number {
  @apply flex justify-end text-sm text-gray-400 p-1 select-none;
  color: rgba(26, 5, 29, 0.5);
}
.count-number-red {
  color: #ff5959;
}

/* title */
.note-title {
  @apply flex flex-col p-4 cursor-move;
  color: #1a051d;
}
.title-text {
  @apply w-full h-full font-medium;
  font-size: 16px;
}
.title-text::-webkit-input-placeholder {
  color: #b2b2cd;
}
.title-text:-moz-placeholder {
  color: #b2b2cd;
}
.title-text:-ms-input-placeholder {
  color: #b2b2cd;
}

/* hr */
.hr {
  @apply w-full h-px;
  background: #ececec;
  transform: scaleY(0.5);
}

/* content */
.content-text {
  @apply w-full h-full;
  color: rgba(26, 5, 29, 0.5);
  font-size: 14px;
}
.content-text::-webkit-input-placeholder {
  color: #b2b2cd;
}
.content-text:-moz-placeholder {
  color: #b2b2cd;
}
.content-text:-ms-input-placeholder {
  color: #b2b2cd;
}

/* action bar */
.action-wrapper {
  @apply mb-2;
  flex: 0 0 2rem;
}
.button {
  @apply py-1 px-2 tracking-widest;
  width: 78px;
  height: 34px;
  font-size: 14px;
  border-radius: 6px;
}
.cancel-button {
  @apply mr-4 text-motif-400;
  border: 1px solid rgba(110, 87, 236, 0.2);
}
.confirm-button {
  @apply text-white border bg-motif;
}
.disabled {
  opacity: 0.6
}
</style>
